<template>
  <v-container>
<!--    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>-->
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-row class="mt-10">
      <v-col class="d-flex flex-1 align-center justify-space-between">
        <span class="header bold text-tcdc-green">miniTCDC</span>
        <GreenLabel name="what's on" @onPress="toEvent" />
      </v-col>
    </v-row>
    <template v-if="form && form.video_url">
      <v-row>
        <v-col>
          <youtube :video-id="videoId"
                   ref="youtube"
                   :player-vars="playerVars"
                   width="100%"
                   height="500px">
          </youtube>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row v-if="form && form.slide_images && form.slide_images.length > 0" class="mb-3">
        <v-col>
          <ImageCarousel :images="form.slide_images"/>
        </v-col>
      </v-row>
      <v-row v-if="form && form.slide_images && form.download_show && form.slide_images.length > 0">
        <GreenButton class="ml-3 mb-3" label="Download as zip" @onPress="openLink(form.download_zip)"></GreenButton>
      </v-row>
    </template>
    <v-row>
      <v-col>
        <div class="vhtml" v-if="form" v-html="form[`description_${lang}`]"></div>
      </v-col>
    </v-row>
    <template v-if="form && form.video_url">
      <v-row v-if="form && form.slide_images && form.slide_images.length > 0" class="mb-3">
        <v-col>
          <ImageCarousel :images="form.slide_images"/>
        </v-col>
      </v-row>
      <v-row v-if="form && form.slide_images && form.download_show && form.slide_images.length > 0">
        <GreenButton class="ml-3 mb-3" label="Download as zip" @onPress="openLink(form.download_zip)"></GreenButton>
      </v-row>
    </template>
    <v-row>
      <v-col>
        <span class="text-tcdc-green bold header">miniTCDC</span>
      </v-col>
    </v-row>
    <v-row class="mb-10">
      <v-col
        cols="12"
        md="7"
        lg="6"
        class="tcdc-map-height d-relative"
        :class="{
          'pr-5': $vuetify.breakpoint.mdAndUp,
          'pb-0': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <GmapMap
          :center="{ lat: 13.87, lng: 100.9925 }"
          :zoom="5.7"
          style="width: 100%; height: 90%;"
        >
          <template v-for="(m, index) in miniByBranch">
              <GmapCustomMarker
                      :key="index"
                      v-if="m.location && m.location.lat && m.location.lon"
                      :marker="{ lat: m.location.lat, lng: m.location.lon }"
                      @click.native="markerHandler(m.id)"
              >
                <CustomMarkerAnimation
                  v-if="selectedBranch === m.id"
                  :color="m.mini_type.marker_color"
                  :bounce-color="m.mini_type.marker_color"
                  class="cursor-pointer"
                  @click.native="selectedBranchHandler(m.id)"
                />
                <CustomMarker
                        v-else
                        class="cursor-pointer"
                        :color="m.mini_type.marker_color"
                        @click.native="selectedBranchHandler(m.id)"
                />
              </GmapCustomMarker>
          </template>
        </GmapMap>
        <div class="pt-5">
          <GreenLabel name="quick search" @onPress="onHandleModal" class="label-max-width" />
        </div>
        <BranchModal
            :visible="dialogVisible"
            @onSelect="afterSelect"
            @onClose="onHandleModal"
        />
      </v-col>
      <v-col
        cols="12"
        md="5"
        lg="6"
        class="tcdc-map-height tcdc-map-scroll"
        :class="{ 'pl-5': $vuetify.breakpoint.mdAndUp }"
      >
        <!-- <template v-for="(item, index) of markers"> -->
        <MapCard :item="miniByBranch && miniByBranch.find(item => item.id == selectedBranch)" :showDivider="false" />
        <!-- </template> -->
      </v-col>
    </v-row>
    <v-row id="mini-about-expand">
      <v-col>
        <AboutExpandable mode="about" :state="routeHash && routeHash === '#network' ? 2:routeHash && routeHash === '#contact' ? 3:null" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImageCarousel from "../../components/carousels/ImageCarousel";
import GreenLabel from "../../components/labels/GreenLabel";
import GreenButton from "../../components/buttons/GreenButton";
import MapCard from "../../components/cards/MapCard";
import BranchModal from "../../components/modals/BranchModal";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import CustomMarker from "../../components/markers/CustomMarker";
import CustomMarkerAnimation from "../../components/markers/CustomMarkerAnimation";
import AboutExpandable from "../../components/expandables/AboutExpandable";
import { mapState } from "vuex";
import { getIdFromUrl } from 'vue-youtube'
import { mapStyles } from "../../config";
import Loading from 'vue-loading-overlay';
import { Utils } from "@/util/Utils";

export default {
  components: {
    GreenButton,
    ImageCarousel,
    GreenLabel,
    MapCard,
    BranchModal,
    GmapCustomMarker,
    CustomMarker,
    CustomMarkerAnimation,
    AboutExpandable,
    Loading
  },
  computed:{
    ...mapState({
      form : state=>{
          if (state.About.form) {
              return state.About.form;
          }
          return {}
      },
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      tagName: state => state.Branch.tag_name,
      lang: state => state.Branch.lang,
      miniByBranch: state => state.Branch.miniByBranch
    }),
    branchChanged: function () {
      return this.branchName;
    },
    routeHash: function () {
      return this.$route.hash;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
        let path;
        for (const b of this.allBranches) {
            if (this.branchId === b.branch_id) {
                if (this.branchId === 0) {
                    path = `/home`;
                    break;
                }
                path = `/home/${b.tag_name}`;
                break;
            }
        }
        this.items[0].to = path;
      if (this.branchId === 0) {
          return this.$router.push(`/${this.lang}`+'/about-main');
      }
      if (!this.miniByBranch) {
          this.isLoading = true;
          // console.log('see id', this.branchId);
          if (this.branchId === 5) {
              this.$store.dispatch('Branch/getMiniByBranch', { branch_id: this.branchId, lang: this.lang });
          }
          this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
          this.$store.dispatch("About/getAboutById",{
              id: this.branchId,
              lang: this.lang
          }).then(async res => {
              if (res.response_code === 200) {
                  await this.$store.dispatch("About/setFormAbout", res.result);
                  this.$forceUpdate();
                  if (this.branchId === 5) {
                      return this.$router.push(`/${this.lang}`+`/mini-tcdc/about/mini-tcdc`);
                  } else {
                      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
                      return this.$router.push(`/${this.lang}`+`${branch}/about`);
                  }
              } else {
                  console.log('data not found');
              }
              this.isLoading = false;
          });
      }
    },
    routeHash: async function () {
      if (this.routeHash) {
        await new Promise(x => setTimeout(x, 1000));
        this.$vuetify.goTo('#mini-about-expand');
      }
    }
  },
  methods: {
    openLink(url) {
      if (url) {
        window.open(url);
      }
    },
    getIdFromYoutube(url){
      this.videoId = getIdFromUrl(url)
    },
    async toEvent() {
        this.isLoading = true;
        await this.$store.dispatch("Branch/getBranchById", this.form.branch_id);
        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
          branch_id: this.form.branch_id,
          lang: this.lang
        });
        this.isLoading = false;
        this.$router.push(`/${this.lang}`+'/home');
    },
    markerHandler(id) {
      // if id is a number it will not work
      const elementId = `#map-${id}`;
      const branchElement = this.$el.querySelector(elementId);
      // branchElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
    },
    onHandleModal() {
      this.dialogVisible = !this.dialogVisible;
    },
    selectedBranchHandler(id) {
      // this.selectedBranchNo = index.id;
      this.selectedBranch = id;
    },
    afterSelect(name) {
      for (let item of this.miniByBranch) {
        if (item.branch_name === name) {
          this.selectedBranch = item.id;
          this.dialogVisible = false;
        }
      }
    }
  },
  async created() {
    let miniId = 5;
    this.$store.dispatch("About/getAboutById",{
      id: miniId,
      lang: this.lang
    }).then(res => {
      if (res.response_code == 200) {
        this.$store.dispatch("About/setFormAbout", res.result);
      } else {
        console.log('data not found');
      }
    });
    await this.$store.dispatch('Branch/getMiniByBranch', { branch_id: miniId, lang: this.lang });
    await this.$store.dispatch("Branch/getBranchById", miniId);
    await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", { branch_id: miniId, lang: this.lang });
    await this.$store.dispatch("About/getAboutAllMenu", { branch_id: miniId, lang: this.lang });
    if (!this.miniByBranch) {
      // id 5 for branch mini
      let params = { id: this.$route.params.branch, lang: this.lang };
      this.$store.dispatch('Branch/getMiniByBranch', params).then(() => {
        for (let item of this.miniByBranch) {
          if (item.location !== null) {
            this.selectedBranch = item.id;
            break;
          }
        }
      });
    } else {
      for (let item of this.miniByBranch) {
        if (item.location !== null) {
          this.selectedBranch = item.id;
          break;
        }
      }
    }

    await this.getIdFromYoutube(this.form.video_url);

    this.items[0].text = this.branchName;
    if (this.form && this.form.branch){
      this.items[0].text = this.form.branch.branch_name
    }
      let path;
      for (const b of this.allBranches) {
          if (this.branchId === b.branch_id) {
              if (this.branchId === 0) {
                  path = `/home`;
                  break;
              }
              path = `/home/${b.tag_name}`;
              break;
          }
      }
      this.items[0].to = path;
  },
  async mounted() {
    if (this.routeHash) {
      await new Promise(x => setTimeout(x, 1000));
      this.$vuetify.goTo('#mini-about-expand');
    }
  },
  data: () => ({
    videoId: 'lG0Ys-2d4MA',
    mapOptions: mapStyles,
    playerVars: {
      autoplay: 1
    },
    seeBigger: false,
    isLoading: false,
    selectedBranch: 1,
    selectedBranchNo: 1, // TODO :: set initial value when fetch marker finished
    dialogVisible: false,
    visibleFull: false,
    markers: [
      // {
      //   position: {
      //     lat: 13,
      //     lng: 100
      //   },
      //   id: "one",
      //   title: "KHONKEAN University",
      //   titleContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      //   contact: "Contact",
      //   contactContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      //   time: "Opening hours",
      //   timeContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
      // },
      // {
      //   position: {
      //     lat: 18,
      //     lng: 100
      //   },
      //   id: "two",
      //   title: "CHULA University",
      //   titleContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      //   contact: "Contact",
      //   contactContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      //   time: "Opening hours",
      //   timeContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
      // },
      // {
      //   position: {
      //     lat: 16,
      //     lng: 104
      //   },
      //   id: "three",
      //   title: "KASETSART University",
      //   titleContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      //   contact: "Contact",
      //   contactContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
      //   time: "Opening hours",
      //   timeContent:
      //     "Lorem ipsum dolor sit amet, consec- tetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat."
      // }
    ],
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: true,
        to: "/home/:branch"
      },
      {
        text: "ABOUT",
        disabled: false,
        to: "/about-main"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
.tcdc-map-height {
  height: 600px;
}
.tcdc-map-scroll {
  overflow-y: scroll;
}
// .tcdc-map-card-border-green {
//   border-bottom: 2px solid $tcdcGreen;
// }
// .tcdc-map-card-border-green:last-child {
//   border-bottom: 0px solid white;
// }
.label-max-width {
  max-width: 250px;
}
</style>
